import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { useSubheader } from '../../../_metronic/layout';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
  },
}));

export function OnDemandPaymentsCancelPage() {
  const classes = useStyles();
  const subheader = useSubheader();
  subheader.setTitle('On-demand payments');

  return (
    <div className={classes.root}>
      <div className="dci-title">Payment process cancelled.</div>
    </div>
  );
}
